var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('h2',{staticClass:"headline",class:{
    'headline-large': _vm.headlineSize === 'large',
    'headline-center': _vm.headlinePosition === 'center',
    'headline-left': _vm.headlinePosition === 'left',
  }},[_vm._v(_vm._s(_vm.headline))]),_c('div',{staticClass:"promoted-video"},[_c('VideoCard',{attrs:{"video":_vm.promotedVideo,"size":"big"}})],1),_c('div',{staticClass:"videos"},_vm._l((_vm.standardVideos),function(video){return _c('div',{key:video.id,staticClass:"video"},[_c('VideoCard',{attrs:{"video":video}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }